// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import device from './modules/device'
import VuexPersistence from 'vuex-persist'
Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  // 通过reducer指定需要持久化的状态，排除accountList
  reducer: state => {
    // 避免直接修改原状态
    const { accountList,phoneInfo, ...rest } = state
    // 返回不包含accountList的状态对象
    return rest
  },
})
const store = new Vuex.Store({
  state: {
    language: 'cn',
    showLogin: false,
    showLoginShort: '',
    userInfo: {}, //用户信息
    accountList: [], //用户多账号信息
    phoneInfo:{},//手机号登录/注册信息
    banner: [], // 轮播图片
    isLogin: 0,
    actIndex: localStorage.getItem('actIndex') || 1,
  },
  mutations: {
    setAttr(state, data) {
      state[data.name] = data.val
    },
    setShowLogin(state, value) {
      state.showLogin = value
    },
    setShowLoginShort(state, value) {
      state.showLoginShort = value
    },
    // 刷新getuser
    getuserVuex(state) {
      state.getusercallback()
    },
    // 刷新详情信息
    getShortDetail(state) {
      state.upShort()
    },
    clearCookieVuex(state) {
      state.clearCookieCallback()
    },
    // //清除vuex
    clearUserData(state) {
      state.userInfo = {}
      state.phoneInfo = {}
      state.accountList = []
      state.isLogin = 0
      state.showLoginShort = ''
      state.actIndex = 1
    },
  },
  modules: { device },
  plugins: [vuexLocal.plugin],
})

export default store
